import { callAPI } from '../../../../services/api.service';

// Service function to get users
export const getUsersService = async (currentPage: number, search?: string, role?: string) => {
    try {
        let url = `admin/user/admin?pageNumber=${currentPage}`;
        if (role) url += `&role=${encodeURIComponent(role)}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        const data = await callAPI(url);
        return {
            users: data?.users || [],
            totalPages: data?.totalPages || 0,
            totalRecords: data?.totalRecords || 0,
        };
    } catch (error) {
        throw new Error('Error fetching users');
    }
};

// Service function to search users
export const searchUsersService = async (searchText: string) => {
    try {
        const data = await callAPI(`admin/user/admin-user-search?search=${searchText}`);
        return data?.message || [];
    } catch (error) {
        throw new Error('Error searching users');
    }
};

// Service function to get user details by ID
export const getUserDetailsService = async (id: string) => {
    try {
        const data = await callAPI(`admin/user?id=${id}`);
        return data || null;
    } catch (error) {
        throw new Error('Error fetching user details');
    }
};

// Service function to delete user
export const deleteUserService = async (userId: string) => {
    try {
        const response = await callAPI(`admin/user/delete`, {
            email: userId
        });
        return response;
    } catch (error) {
        throw new Error('Error deleting user');
    }
};
